import { observable } from "@chorda/core";
import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { Button, Buttons, Card } from "chorda-bulma";
import { CatApi } from "../../api";
import { BgImage, FaIcon } from "../../helpers";
const asyncImageLoad = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.addEventListener('load', () => {
            console.log('image loaded');
            resolve(url);
        });
    });
};
export const Vote = () => {
    return {
        injections: {
            imageUrl: () => observable(null),
            imageLoading: () => observable(false),
        },
        joints: {
            autoLoad: ({ imageUrl, imageLoading }) => {
                imageLoading.$value = true;
                CatApi.api
                    .searchImages({ breed_id: 'norw' })
                    .then(breeds => asyncImageLoad(breeds[0].url))
                    .then((url) => {
                    imageLoading.$value = false;
                    imageUrl.$value = url;
                });
            }
        },
        templates: {
            buttons: {
                css: 'pb-5',
                templates: {
                    content: Buttons({
                        centered: true,
                        buttons: [
                            Button({
                                text: 'Love It',
                                css: 'is-success',
                                leftIcon: FaIcon({ icon: faThumbsUp })
                            }),
                            Button({
                                text: 'Nope It',
                                css: 'is-danger',
                                leftIcon: FaIcon({ icon: faThumbsDown })
                            }),
                        ]
                    })
                }
            },
            image: {
                templates: {
                    content: Card({
                        css: 'catapi-vote-card p-4',
                        content: false,
                        image: BgImage({
                            url$: (scope) => scope.imageUrl,
                            height: 400,
                            as: {
                                templates: {
                                    content: {
                                        joints: {
                                            showHide: ({ $dom, url, $renderer, $patcher }) => {
                                                const name = 'fade';
                                                const show = () => {
                                                    if ($dom.$value && url.$value) {
                                                        const el = $dom.$value;
                                                        el.classList.add(name + '-enter');
                                                        $patcher.queue($renderer.effect(() => {
                                                            el.classList.add(name + '-enter-active' /*, name+'-enter'*/);
                                                            el.classList.remove(name + '-enter');
                                                            const f = (evt) => {
                                                                el.removeEventListener('transitionend', f);
                                                                el.classList.remove(name + '-enter-active');
                                                            };
                                                            el.addEventListener('transitionend', f);
                                                        }));
                                                    }
                                                    else {
                                                        // hidden
                                                    }
                                                };
                                                $dom.$subscribe((next) => {
                                                    if (next) {
                                                        //                                                        next.classList.add(name+'-enter-active', name+'-enter')
                                                    }
                                                });
                                                url.$subscribe(show);
                                            }
                                        },
                                        // reactions: {
                                        //     imageLoading: (v) => ({classes: {'blurry-placeholder': v}})
                                        // },
                                    }
                                }
                            }
                        })
                        // image: Image({
                        //     url$: (ctx: any) => ctx.imageUrl
                        // }),
                    })
                }
            },
        }
    };
};
